import { render, staticRenderFns } from "./ControlsSection.vue?vue&type=template&id=54f75b48&scoped=true"
import script from "./ControlsSection.vue?vue&type=script&lang=js"
export * from "./ControlsSection.vue?vue&type=script&lang=js"
import style0 from "./ControlsSection.vue?vue&type=style&index=0&id=54f75b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f75b48",
  null
  
)

export default component.exports